import { Component, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';

@Component({
  selector: 'app-select-days-optimum-price',
  templateUrl: './select-days-optimum-price.component.html',
  styleUrls: ['./select-days-optimum-price.component.scss']
})
export class SelectDaysOptimumPriceComponent implements OnDestroy {

  public items: any[] = [
    { value: 90, name: 'Últ. 90 días' },
    { value: 180, name: 'Últ. 180 días' },
    { value: 360, name: 'Últ. 360 días' }
  ];

  public daysAgo: any = [];
  public ngxDisabled = false;
  daysAgo$: Subscription;

  constructor(
    public sanitizer: DomSanitizer,
    private sharedService: SharedService
  ) {
    this.daysAgo$ = this.sharedService.sharedDaysOptimumPrice.subscribe(daysAgo => {
      this.daysAgo = daysAgo;
    });
  }

  public style(data: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(data);
  }

  ngOnDestroy() {
    this.daysAgo$.unsubscribe();
  }

  changeDaysAgo(event: any) {
    this.daysAgo = event;
    if (this.daysAgo === 90 || this.daysAgo === 180 || this.daysAgo === 360) {
      this.sharedService.nextDaysOptimumPx = this.daysAgo;
    }
    this.sharedService.nextDaysOptimumPrice = this.daysAgo;
  }
}
